import '../css/about.css';
import '../css/background.css';
import Navbar from '../components/Navbar.jsx';
import Footer from '../components/Footer.jsx';
import photo from '../images/self.jpg';

function About(props) {

    return (
        <div className="background-shapes">
            <div className="about">
                <Navbar currentComponent={props.currentComponent} setCurrentComponent={props.setCurrentComponent} />

                <h1>About</h1>

                <div className="about-content">
                        {/* <div className="about-photo-container"> */}
                            <img src={photo} alt="Pam Hobbs" />
                        {/* </div> */}

                        <div>
                            <p>
                                Pamela is a designer that caters to each individuals style. This is done all while maintaining function, beauty, and comfort. 
                                She specializes in placement, color, balance of materials, and scale. Every detail is considered to create a satisfying end result. 
                                She has been creating harmony for clients in Chicago, Indiana, and Florida for twenty five years. 
                            </p>

                            <p>
                                Her work has been featured in Better Homes and Gardens magazine and several local newspapers. 
                                She has also been a proud recipient of several award winning designs in Indianapolis Decorator's Show House.
                            </p>
                        </div>
                </div>

            </div>

            <Footer />
        </div>
    );
}

export default About;